import React, { ReactNode, memo } from 'react'
import { Grid, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { Maybe } from 'types/graphqlTypes'
import { DISPLAY } from 'constants/display'

const useLaneDetailsRowStyles = makeStyles({
  label: {
    color: brandColors.coolGray5,
  },
})

interface ILaneDetailsRowProps {
  dataTest?: string
  label: ReactNode
  value: Maybe<ReactNode>
}

export const LaneDetailsRow = memo<ILaneDetailsRowProps>(({ dataTest, label, value }) => {
  const classes = useLaneDetailsRowStyles()

  return (
    <Grid data-test={dataTest} container item xs={12}>
      <Grid className={classes.label} item xs={4}>
        <Typography variant='body2'>{label}</Typography>
      </Grid>

      <Grid item>
        <Typography data-test={`${dataTest}-value`} variant='body2'>
          {value ?? DISPLAY.empty}
        </Typography>
      </Grid>
    </Grid>
  )
})
